"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footerNavHeight = exports.UnreadIndicator = exports.NavButton = exports.FooterItemWrapper = exports.Footer = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _sharedStyle = require("../../../sharedStyle");
const {
  colours
} = _uiKit.theme;
const footerNavHeight = exports.footerNavHeight = _sharedStyle.headerHeight;
const Footer = exports.Footer = _styledComponents.default.div.withConfig({
  displayName: "Navstyle__Footer",
  componentId: "sc-1x1kbv9-0"
})(["display:flex;justify-content:space-between;position:absolute;bottom:0;left:0;right:0;height:", "px;width:100vw;z-index:5;background:", ";"], footerNavHeight, colours.PRIMARY_1);
const FooterItemWrapper = exports.FooterItemWrapper = _styledComponents.default.div.withConfig({
  displayName: "Navstyle__FooterItemWrapper",
  componentId: "sc-1x1kbv9-1"
})(["display:inline-block;width:", "%;background:none;text-align:center;position:relative;"], props => Math.floor(100 / props.itemCount));
const NavButton = exports.NavButton = _styledComponents.default.button.withConfig({
  displayName: "Navstyle__NavButton",
  componentId: "sc-1x1kbv9-2"
})(["background:", ";border:none;height:", "px;width:100%;&&:focus{outline:none;}"], _ref => {
  let {
    active
  } = _ref;
  return active ? colours.WHITE : "none";
}, footerNavHeight);
const UnreadIndicator = exports.UnreadIndicator = _styledComponents.default.div.withConfig({
  displayName: "Navstyle__UnreadIndicator",
  componentId: "sc-1x1kbv9-3"
})(["background-color:", ";width:14px;height:14px;border-radius:50%;position:absolute;top:15px;right:39px;border:solid 1px ", ";background-color:", ";"], colours.DISCONTINUED, colours.PRIMARY_1, colours.DISCONTINUED);